import {css} from "@panda/css";

import {SkeletonBox} from "@pg-mono/skeleton-box";

export const SemanticSearchSidebarSkeleton = () => {
    return (
        <div className={wrapper} data-testid="semantic-search-sidebar-skeleton" aria-hidden="true">
            <SkeletonBox className={rounded} width="214px" height="207px" />

            <div className={headingGroup}>
                <SkeletonBox className={rounded} width="70%" height="28px" />
                <SkeletonBox className={rounded} width="43%" height="28px" />
            </div>

            <div className={textGroup}>
                <SkeletonBox className={rounded} width="84%" height="16px" />
                <SkeletonBox className={rounded} width="70%" height="16px" />
            </div>

            <div className={rows}>
                <SkeletonBox className={rounded} width="100%" height="48px" />
                <SkeletonBox className={rounded} width="100%" height="48px" />
                <SkeletonBox className={rounded} width="100%" height="48px" />
            </div>

            <SkeletonBox className={rounded} width="100%" height="152px" />
        </div>
    );
};

const wrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    width: "100%",
    paddingInline: "16px",
    paddingBlock: "24px"
});

const rounded = css({
    flexShrink: 0,
    borderRadius: "8px"
});

const headingGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    width: "100%"
});

const textGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    width: "100%"
});

const rows = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "8px",
    width: "100%"
});
import {css} from "@panda/css";

import {SkeletonBox} from "@pg-mono/skeleton-box";

export const SemanticSearchSidebarSkeleton = () => {
    return (
        <div className={wrapper} data-testid="semantic-search-sidebar-skeleton" aria-hidden="true">
            <SkeletonBox className={rounded} width="214px" height="207px" />

            <div className={headingGroup}>
                <SkeletonBox className={rounded} width="70%" height="28px" />
                <SkeletonBox className={rounded} width="43%" height="28px" />
            </div>

            <div className={textGroup}>
                <SkeletonBox className={rounded} width="84%" height="16px" />
                <SkeletonBox className={rounded} width="70%" height="16px" />
            </div>

            <div className={rows}>
                <SkeletonBox className={rounded} width="100%" height="48px" />
                <SkeletonBox className={rounded} width="100%" height="48px" />
                <SkeletonBox className={rounded} width="100%" height="48px" />
            </div>

            <SkeletonBox className={rounded} width="100%" height="152px" />
        </div>
    );
};

const wrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    width: "100%",
    paddingInline: "16px",
    paddingBlock: "24px"
});

const rounded = css({
    flexShrink: 0,
    borderRadius: "8px"
});

const headingGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    width: "100%"
});

const textGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    width: "100%"
});

const rows = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "8px",
    width: "100%"
});
